/**
 * License Enforcement Script
 * Clean and transparent version for feature gating based on plan
 */

// Define available plans
const Plans = {
  FREE: 'free',
  GROWTH: 'growth',
  PRO: 'professional'
};

// Define features available per plan
const FeatureAccess = {
  [Plans.FREE]: [
    'announcement-bar',
    'basic-slider'
  ],
  [Plans.GROWTH]: [
    'announcement-bar',
    'basic-slider',
    'wishlist',
    'currency-converter'
  ],
  [Plans.PRO]: [
    'announcement-bar',
    'basic-slider',
    'wishlist',
    'currency-converter',
    'chat-widget',
    'advanced-upsell'
  ]
};




// License management
function getUserPlan() {
  return Plans.PRO;
}



// Feature control
function checkFeatureAccess() {
  const currentPlan = getUserPlan();
  const allowedFeatures = FeatureAccess[currentPlan] || [];

  const allFeatureElements = document.querySelectorAll('[data-feature]');

  allFeatureElements.forEach(el => {
    const featureId = el.getAttribute('data-feature');
    if (!allowedFeatures.includes(featureId)) {
      console.warn(`Feature "${featureId}" not allowed for plan "${currentPlan}". Removing...`);
      el.remove();
    }
  });
}

// Optional: Show lock notice instead of removing
function markLockedFeatures() {
  const currentPlan = getUserPlan();
  const allowed = FeatureAccess[currentPlan] || [];

  document.querySelectorAll('[data-feature]').forEach(el => {
    const id = el.getAttribute('data-feature');
    if (!allowed.includes(id)) {
      el.innerHTML = `
        <div class="locked-feature-notice">
          <p>This feature is available on higher plans.</p>
          <a href="/upgrade" class="upgrade-button">Upgrade Now</a>
        </div>
      `;
    }
  });
}


// Run this on page load
document.addEventListener('DOMContentLoaded', async () => {
  // Optionally fetch from server first
  // await fetchAndApplyPlan();

  // Then check access
  checkFeatureAccess();

  // Or use this instead if you want to show upgrade prompts:
  // markLockedFeatures();
});
